import Request from "./index";

export const googleMapsAPIKey = 'AIzaSyAt02wN_72X2ME-RNDPfw0ReRzDtnC-2TY';

export const findLocation = (address: string) =>
  Request.get(`geo-code/?address=${address}`);